import { useState } from "react";

// react-router-dom components
import { useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import Swal from "sweetalert2";
import LoadingOverlay from "react-loading-overlay";
// @mui icons
import Joi from "joi";
// Market Place React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "views/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import { login } from "controllers/UserController";

import { useMaterialUIController, setLogin } from "context";
import getText from "Translator";
import { createNewpassword } from "controllers/UserController";
import { TextField } from "@mui/material";

function Login() {
  const [username, setUsername] = useState("");
  const [loginfrom, setLoginFrom] = useState("user");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState("getpass");
  const [controller, dispatch] = useMaterialUIController();
  const navigate = useNavigate();

  const handleSubmitClick = async () => {
    try {
      if (mode == "getpass") {
        if (username.length < 10) {
          Swal.fire({
            text: getText(`invaliphoneformat`, "fa"),
            icon: "error",
            confirmButtonText: getText(`ok`, "fa"),
          });
          return;
        }
        const newUser = {
          username,
          lang: "fa",
          from: "app",
        };
        setLoading(true);
        const res = await createNewpassword("fa", newUser);
        setLoading(false);
        if (res.success) {
          Swal.fire({
            text: `${res.message}  `,
            position: "top-right",
            showConfirmButton: false,
            timerProgressBar: true,
            timer: 3000,
            color: "green",
          });
          setLoginFrom(res.data);
          setMode("login");
        } else {
          Swal.fire({
            text: `${res.message} (${res.code})`,
            icon: "error",
            confirmButtonText: getText(`ok`, "fa"),
          });
        }
      } else {
        const schema = Joi.object({
          username: Joi.string().required(),
          password: Joi.string().required(),
        });

        const { error } = schema.validate({
          username,
          password,
        });

        if (error) {
          Swal.fire({
            text: `${error.details[0].message}  `,
            icon: "error",
            confirmButtonText: "OK",
          });
          return;
        }
        setLoading(true);
        const newUser = {
          username,
          password,
          lang: "fa",
          from: "app",
          loginfrom,
        };
        const res = await login("fa", newUser);
        setLoading(false);
        if (res.success) {
          setLogin(dispatch, res.data);
          if (res.data.loginfrom == "fromfile") {
            //***************

            let menu = {};
            menu.capsule = res.data.capsule;
            menu.capsuleText = "";
            menu.title = res.data.title;
            menu.titleText = "";
            menu.isMyFile = true;
            menu.limitedFile = false;
            menu.file = res.data.id;
            menu.nationalCode = res.data.nationalCode;
            menu.showResultOfFile = false;
            menu.from = "menu";
            menu.headline = "complaints";
            menu.allowpages = res.data.allowpages;
            menu.visitedpageslist = [];
            await localStorage.setItem("$menu", JSON.stringify(menu));

            navigate("/pageview");

            //************
            return;
          }
          navigate("/main/complaints", { replace: true });
          // clearForm();
        } else {
          Swal.fire({
            text: `${res.message} (${res.code})`,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
        if (res.code === 401) {
          navigate("/", { replace: true });
        }
      }
    } catch (err) {
      console.log(err);
      Swal.fire({
        text: getText(`generalerror`, "fa"),
        icon: "error",
        confirmButtonText: getText(`ok`, "fa"),
      });
    }
  };
  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={1}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            {getText("sign-in", "fa")}
          </MDTypography>
          <Grid
            container
            justifyContent="center"
            sx={{ mt: 0.1, mb: 0.1 }}
          ></Grid>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <LoadingOverlay active={loading} spinner text="Please wait ...">
            <MDBox component="form" role="form">
              <MDBox mb={2}>
                <TextField
                  type="tel"
                  label={getText("usernamemobile", "fa")}
                  variant="standard"
                  fullWidth
                  value={username}
                  onChange={(event) => {
                    setUsername(event.target.value);
                  }}
                  // onKeyDown={(event) => {
                  //   console.log("enter press here! ", event.key);
                  //   if (event.key === "Enter") {
                  //     handleSubmitClick();
                  //   }
                  // }}
                />
              </MDBox>
              {mode == "login" && (
                <MDBox mb={2}>
                  <TextField
                    type="tel"
                    security
                    label={getText("password", "fa")}
                    variant="standard"
                    fullWidth
                    value={password}
                    onChange={(event) => {
                      setPassword(event.target.value);
                    }}
                  />
                </MDBox>
              )}
              <MDBox mt={4} mb={1}>
                <MDButton
                  variant="gradient"
                  color="info"
                  fullWidth
                  onClick={() => {
                    handleSubmitClick();
                  }}
                >
                  {getText(
                    mode == "login" ? "signin" : "getcode",
                    "fa"
                  )}
                </MDButton>
              </MDBox>
            </MDBox>
          </LoadingOverlay>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Login;
